import React from "react";

import PCTemplate from "../../components/pc-template";
import HelmetSeo from "../../components/HelmetSeo";
import { pageSeoConfig } from "../../config/pageSeo";

import { FloatButton } from "antd";

const Home: React.FC = () => {
  const seoMeta = pageSeoConfig.home;

  return (
    <>
      <HelmetSeo title={seoMeta.title} description={seoMeta.description} />
      <PCTemplate />

      <FloatButton.BackTop />
    </>
  );
};

export default Home;
